





















import Vue from 'vue'
import { formatOneDecimal } from '@/common/utils/common'

export default Vue.extend({
  props: {
    totalProductCount: {
      type: Number,
      required: false,
      default: 0
    },
    totalSearchPages: {
      type: Number,
      required: false,
      default: 0
    },
    currentSearchPage: {
      type: Number,
      required: false,
      default: 0
    },
    searchTitle: {
      type: String,
      required: true
    }
  },
  computed: {
    title(): string {
      return this.searchTitle || 'すべてのカテゴリー'
    }
  },
  methods: {
    formatOneDecimal
  }
})
